import React from 'react';
import {SheetView} from '../components/helpful'; // Assuming SheetView is imported from another file

/* The class `Documents` renders a `SheetView` component with a specified category prop. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default  class Documents extends React.Component {
 
 
  render() {
   
    return (
      <div>
        <SheetView category={this.props.category}/>
      </div>
    );
  }
}

